// extracted by mini-css-extract-plugin
module.exports = {"login-with-facebook-btn":"FacebookButton_login-with-facebook-btn__1qdBB"};